<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">其他审核项</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>理想的另一半：</label>
          <el-select v-model="idealHimState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in idealHimStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>闲暇喜好：</label>
          <el-select v-model="hobbyState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in hobbyStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="更新时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
          <el-checkbox v-model="limitState" :true-label="1" :false-label="0" style="margin-left: 8px;">有限制</el-checkbox>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="success" v-loading="updateLoading" @click="batchUpdate(2)">批量通过</el-button>
          <el-button type="danger" v-loading="updateLoading" @click="batchUpdate(3)">批量不通过</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="更新时间" v-if="checkColList.indexOf('更新时间') > -1" width="200"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="120">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户" v-if="checkColList.indexOf('用户') > -1" >
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
              <p>身高：{{scope.row.height}}cm</p>
              <p>期望结婚时间：<span v-if="scope.row.marryTime">{{scope.row.marryTime == 1? "半年内" : scope.row.marryTime - 1 + "年内"}}</span></p>
            </template>
          </el-table-column>
          <el-table-column property="" label="理想的另一半" v-if="checkColList.indexOf('理想的另一半') > -1">
            <template #default="scope">
              <p style="margin-bottom: 8px" v-if="scope.row.idealHim">{{scope.row.idealHim}}</p>
              <el-tag :type="scope.row.idealHimState == 1?'primary':scope.row.idealHimState == 2?'success':scope.row.idealHimState == 3?'danger':'info'">
                {{scope.row.idealHimState == 1?'待审核':scope.row.idealHimState == 2?'已通过':scope.row.idealHimState == 3?'不通过':'未提交'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="120">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button v-if="scope.row.idealHimState == 1 || scope.row.idealHimState == 3" type="primary" size="small" @click="updateReState(scope.$index, scope.row, 2, 1)" v-loading="scope.row.reLoading">通过</el-button>
                <el-button v-if="scope.row.idealHimState == 1 || scope.row.idealHimState == 2" type="danger" size="small" @click="updateReState(scope.$index, scope.row, 3, 1)" v-loading="scope.row.reLoading">不通过</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column prop="" label="闲暇喜好" v-if="checkColList.indexOf('闲暇喜好') > -1">
            <template #default="scope">
              <p style="margin-bottom: 8px" v-if="scope.row.hobby">{{scope.row.hobby}}</p>
              <el-tag :type="scope.row.hobbyState == 1?'primary':scope.row.hobbyState == 2?'success':scope.row.hobbyState == 3?'danger':'info'">
                {{scope.row.hobbyState == 1?'待审核':scope.row.hobbyState == 2?'已通过':scope.row.hobbyState == 3?'不通过':'未提交'}}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="120">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button v-if="scope.row.hobbyState == 1 || scope.row.hobbyState == 3" type="primary" size="small" @click="updateReState(scope.$index, scope.row, 2, 2)" v-loading="scope.row.reLoading">通过</el-button>
                <el-button v-if="scope.row.hobbyState == 1 || scope.row.hobbyState == 2" type="danger" size="small" @click="updateReState(scope.$index, scope.row, 3,2)" v-loading="scope.row.reLoading">不通过</el-button>
              </el-space>
            </template>
          </el-table-column>
<!--          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">-->
<!--            <template #default="scope">-->
<!--              <UserLog :user-log-list="scope.row.userLogList" />-->
<!--            </template>-->
<!--          </el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getPerfectPageList,
  updateGreetingTermState,
  updatePerfectState
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import OtherDialog from "@/views/review/components/OtherDialog";

export default {
  name: "ReviewOther",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //理想
      idealHimStateArray:[
        {label : '不限制', value : -1},
        {label : '未提交', value : 0},
        {label : '待审核', value : 1},
        {label : '已通过', value : 2},
        {label : '不通过', value : 3}
      ],
      idealHimState: -1,

      //闲暇喜好
      hobbyStateArray: [
        {label : '不限制', value : -1},
        {label : '未提交', value : 0},
        {label : '待审核', value : 1},
        {label : '已通过', value : 2},
        {label : '不通过', value : 3}
      ],
      hobbyState: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      limitState: 0,

      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['更新时间', '头像', '用户', '理想的另一半', '闲暇喜好', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.idealHimState = -1;
      this.hobbyState = -1;
      this.limitState = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['hobbyState'] = this.hobbyState;
      param['idealHimState'] = this.idealHimState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getPerfectPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      // if(column.label == '用户日志') {
      //   Dialog.open({
      //     title: '用户日志',
      //     component: UserLogDialog,
      //     data: {
      //       id: row.userId
      //     },
      //     close: () => {
      //       row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
      //     }
      //   })
      // }

    },


    //批量审核
    batchUpdate(state) {
      if(this.idArray.length > 0) {
        let _title = state == 2?'确定批量通过吗？':'确定批量不通过吗？'
        Dialog.open({
          title: _title,
          component: OtherDialog,
          data: {
            idArr: this.idArray,
            state: state,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //审核
    updateReState(idx, row, state, type) {
      this.$confirm('确定' + (state == 2?'通过':'不通过') +'【' + row.nickName + '】的' + (type == 1?'理想的另一半':'闲暇喜好') + '?').then(()=>{
        this.pageDataList[idx]['reLoading'] = true
        let idArr = []
        idArr.push(row.userId)
        let param = {}
        param['idArr'] = idArr
        if(type == 1) {
          param['idealHimState'] = state
        }else {
          param['hobbyState'] = state
        }
        postFormData(updatePerfectState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            if(type == 1) {
              row.idealHimState = state
            }else {
              row.hobbyState = state
            }
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['reLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['reLoading'] = false
        })
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
